import lodash from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Paper, Button, LinearProgress } from '@material-ui/core';
import {
    Checkbox, InputNumber, Input, message, Spin,
} from 'antd';
import SaveIcon from '@material-ui/icons/Save';
import { updateBlemishReportRequest } from '../../redux/actions/questions_actions/update_blemish_report.actions';
import {
    createBikeLeadUpgrades,
    deleteBikeLeadUpgrades,
    updateBikeLeadUpgrades,
} from '../../requests/bike_lead_upgrades_request';
import { BIKE_UPGRADE_OPTIONS_LIST } from '../../../constants/bikeUpgrades';

const { TextArea } = Input;

class CustomerRemarks extends React.Component {
    constructor(props) {
        super(props);

        const initialNote = lodash.get(this.props, 'blemish_report.questions.question_46.note') || '';

        this.state = {
            note: initialNote,
            initialNote,
            isOtherRemarksSelected: false,
            initialUpgrades: null,
            upgrades: this.buildInitialUpgrades(),
            isFetching: false,
        };
    }

    static getDerivedStateFromProps(props, state) {
        const reduxNote = lodash.get(props, 'blemish_report.questions.question_46.note') || '';

        if (reduxNote !== state.initialNote) {
            return {
                note: reduxNote,
                initialNote: reduxNote,
            };
        }
        return null;
    }

    buildInitialUpgrades = () => {
        const savedUpgrades = this.props.bikeUpgrades;

        return BIKE_UPGRADE_OPTIONS_LIST.map((upgradeName) => {
            const upgradeData = savedUpgrades?.find((opt) => opt.name === upgradeName);

            if (upgradeData) {
                return {
                    ...upgradeData,
                    checked: true,
                };
            }

            return {
                name: upgradeName,
                price: '',
                checked: false,
            };
        });
    };

    checkChangedUpgrades = (upgradesList, initUpgradesList) => upgradesList.map((upgrade) => {
        const prevUpgradeData = initUpgradesList?.find((opt) => opt.name === upgrade.name);
        let method = '';

        const priceChanged = prevUpgradeData && upgrade.checked && upgrade.price && upgrade.price !== prevUpgradeData.price;
        const priceDelete = prevUpgradeData && !upgrade.checked;
        const newUpgrade = !prevUpgradeData && upgrade.checked && upgrade.price;


        if (priceChanged) {
            method = 'update';
        } else if (priceDelete) {
            method = 'delete';
        } else if (newUpgrade) {
            method = 'create';
        }

        return { ...upgrade, method };
    });


    handlerClickSave = async () => {
        const { bikeLeadId } = this.props;
        const bikeUpgrades = this.state.upgrades;
        const initialBikeUpgrades = this.state.initialUpgrades;
        const upgradesUpdatedList = this.checkChangedUpgrades(bikeUpgrades, initialBikeUpgrades);
        const filteredUpgradesList = upgradesUpdatedList.filter((opt) => opt.method);

        let response = null;

        if (Array.isArray(filteredUpgradesList) && filteredUpgradesList.length) {
            this.setState({ isFetching: true });
            // eslint-disable-next-line no-restricted-syntax
            for (const currentUpgrade of filteredUpgradesList) {
                const updateData = { name: currentUpgrade.name, price: currentUpgrade.price };

                if (currentUpgrade.method === 'create') {
                    response = await createBikeLeadUpgrades(bikeLeadId, updateData);
                }
                if (currentUpgrade.method === 'update') {
                    response = await updateBikeLeadUpgrades(bikeLeadId, currentUpgrade._id, updateData);
                }
                if (currentUpgrade.method === 'delete') {
                    response = await deleteBikeLeadUpgrades(bikeLeadId, currentUpgrade._id);
                }
            }
        } else if ((!filteredUpgradesList || !filteredUpgradesList.length) && this.state.note === this.state.initialNote) {
            message.warn('There no changes to save');
        }

        if (Array.isArray(response?.options?.upgrades)) {
            this.setState({ initialUpgrades: response?.options?.upgrades });
        }

        if ((Array.isArray(filteredUpgradesList) && filteredUpgradesList.length) || this.state.note !== this.state.initialNote) {
            const selectedRemarksStrings = bikeUpgrades.filter((opt) => opt.checked && opt.price)?.map((opt) => opt.name)?.join(', ') || '';

            let updatedNote = '';

            if (selectedRemarksStrings) {
                updatedNote = `${selectedRemarksStrings}, `;
            }

            if (this.state.note) {
                const currentNote = this.state.note;
                const filterUpgradesValues = currentNote.split(', ').filter((opt) => selectedRemarksStrings.indexOf(opt) === -1).join(', ');

                updatedNote += filterUpgradesValues;
            }

            this.props.updateBlemishReportRequest({
                lead_id: this.props.blemish_report.ref_lead,
                question: 'question_46',
                note: updatedNote,
            });
        }

        this.setState({ isFetching: false });
    }

    handlerChange = (event) => {
        this.setState({ note: event.target.value });
    }

    handleCheckUpgrade = (e, field) => {
        this.setState((prevState) => {
            const newUpgrades = [...prevState.upgrades];
            const fieldIdx = newUpgrades.findIndex((upgrade) => upgrade.name === field);

            newUpgrades[fieldIdx] = {
                ...newUpgrades[fieldIdx],
                checked: e.target.checked,
                price: !e.target.checked ? '' : newUpgrades[fieldIdx].price,
            };

            return {
                ...prevState,
                upgrades: [...newUpgrades],
            };
        });
    };

    handleIsOtherSelected = (event) => {
        this.setState({ isOtherRemarksSelected: event.target.checked });
    }

    handleUpgradePriceChange = (value, fieldName) => {
        this.setState((prevState) => {
            const newUpgrades = [...prevState.upgrades];
            const fieldIdx = newUpgrades.findIndex((upgrade) => upgrade.name === fieldName);

            newUpgrades[fieldIdx] = { ...newUpgrades[fieldIdx], price: value };

            return {
                ...prevState,
                upgrades: [...newUpgrades],
            };
        });
    }


    render() {
        const isLoading = this.props.blemish_report_loading;

        if (this.props.bikeUpgrades && !this.state.initialUpgrades) {
            const updatedUpgrades = this.buildInitialUpgrades();

            this.setState((prevState) => ({
                ...prevState,
                upgrades: [...updatedUpgrades],
                initialUpgrades: [...this.props.bikeUpgrades],
            }));
        }

        return (
            <Spin spinning={this.state.isFetching} tip="Saving...">
                <Paper style={{ padding: 24, marginTop: 10 }}>
                    <h3>Additional/Aftermarket Parts</h3>


                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {
                            this.state.upgrades.map((opt) => (
                                <div key={opt.name}>
                                    <Checkbox
                                        onChange={(e) => this.handleCheckUpgrade(e, opt.name)}
                                        checked={opt.checked}
                                        style={{ margin: '0 0 10px 0' }}
                                    >
                                        {opt.name}
                                    </Checkbox>

                                    {
                                        opt.checked
                                            ? (
                                                <div style={{ margin: '0 0 5px' }}>
                                                    <InputNumber
                                                        onChange={(value) => this.handleUpgradePriceChange(value, opt.name)}
                                                        value={opt.price}
                                                        size="small"
                                                        min={0}
                                                        placeholder="Enter price"
                                                        formatter={(value) => `£ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                        parser={(value) => value.replace(/£\s?|(,*)/g, '')}
                                                    />
                                                </div>
                                            )
                                            : ''
                                    }


                                </div>
                            ))
                        }
                    </div>

                    <div>
                        <Checkbox
                            onChange={this.handleIsOtherSelected}
                            checked={this.state.isOtherRemarksSelected}
                            style={{ margin: '0 0 10px 0' }}
                        >
                            Other
                        </Checkbox>
                    </div>

                    {isLoading && <LinearProgress style={{ marginBottom: 5 }} />}

                    {
                        this.state.isOtherRemarksSelected
                            ? (
                                <>
                                    <TextArea
                                        autoSize
                                        placeholder="Does the bike have any aftermarket parts?
                                    (exhaust, levers, tail tidy, crash bungs, heated grips)?"
                                        value={this.state.note}
                                        onChange={this.handlerChange}
                                        disabled={isLoading}
                                    />
                                </>
                            )
                            : ''
                    }

                    <div style={{ display: 'flex', flexDirection: 'row-reverse', marginTop: 10 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<SaveIcon />}
                            onClick={this.handlerClickSave}
                            disabled={isLoading || this.state.isFetching}
                        >
                            Save
                        </Button>
                    </div>
                </Paper>
            </Spin>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        blemish_report,
        blemish_report_loading,
        error,
    } = state.Leads.Lead_profile.Lead_blemish_report;
    const { bike_details } = state.Leads.Lead_profile.Ref_bike_lead;
    return {
        blemish_report,
        blemish_report_loading,
        error,
        bikeLeadId: bike_details?._id,
        bikeUpgrades: bike_details?.upgrades,
    };
};

export default connect(mapStateToProps, {
    updateBlemishReportRequest,
})(CustomerRemarks);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/CustomerRemarks.js